export const CHECK_IN_TIME = "Check-in time";
export const CHECKOUT_TIME = "Checkout time";
export const CHECK_IN_INFO_COPY =
  "After completing your booking, the host provider will reach out to you via email to make plans for your check-in and answer any property specific questions.";
export const ADDRESS = "Address";
